import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';
import './i18n';
import './styles/global.css';
import App from './App';

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN as string | undefined;
const posthogHost =
  (import.meta.env.VITE_PUBLIC_POSTHOG_HOST as string | undefined) ?? 'https://eu.i.posthog.com';

const posthogOptions = {
  api_host: posthogHost,
  defaults: '2026-01-30',
} as const;

const tree = (
  <StrictMode>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </StrictMode>
);

createRoot(document.getElementById('root')!).render(
  posthogKey ? (
    <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
      {tree}
    </PostHogProvider>
  ) : (
    tree
  ),
);
